var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconHood(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 239.72 102.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3,.cls-4{fill:#fff;stroke:#231f20;stroke-miterlimit:2.61;fill-rule:evenodd;}.cls-3{stroke-width:2px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(0.75 1)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M110.86,98C60.86,95,27.42,69.75,0,73.21,15.32,56.06,28,16.69,38.82,10.34c14-6.27,40-8.15,80.29-10.34,40.31,2.19,66.3,4.07,80.29,10.34,10.8,6.35,23.5,45.72,38.83,62.87-24.75-3.13-54.42,17.15-96.7,23.31-4.57.66-9.29,1.16-14.17,1.45Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "collar_hood",
    "data-name": "collar hood"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M110.86,98C60.86,95,27.42,69.75,0,73.21,15.32,56.06,28,16.69,38.82,10.34c14-6.27,40-8.15,80.29-10.34,40.31,2.19,66.3,4.07,80.29,10.34,10.8,6.35,23.5,45.72,38.83,62.87-24.75-3.13-54.42,17.15-96.7,23.31-4.57.66-9.29,1.16-14.17,1.45Z",
    transform: "translate(0.75 1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M38.82,17.58c53.51-13.83,107-14.52,160.58,0C208.47,32.37,126.61,98,126.61,98c-6.11,4.52-9.56,4.35-16.11-.48C110.5,97.5,25.6,28.71,38.82,17.58Z",
    transform: "translate(0.75 1)"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHood);
export default __webpack_public_path__ + "static/media/icon-hood.8e00ca0ff0538866a458a1f2282936b6.svg";
export { ForwardRef as ReactComponent };